"use strict";
// reference: https://git.woa.com/tencent-cloud-commerce-platform/tccp-strategy/tree/master/strategy-model/src/main/java/com/tencent/tccp/strategy/model/entity
Object.defineProperty(exports, "__esModule", { value: true });
